function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scroll_sync_mixin from '../../mixins/scroll_sync_mixin';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
import MonitoringDriverService from '@/apps/data-platform/services/reports/monitoring_driver_connection';
import MonitoringAccessService from '@/apps/data-platform/services/reports/monitoring_access';
import ProjectsService from '@/apps/data-platform/services/master_data/projects_service';
import tasks from '@/js/tasks';
import { envConfig } from '@/js/constants';
import PaginationBasic from '@/components/PaginationBasic.vue';
import ModalConfirm from '@/components/ModalConfirm';
import utils from '@/js/utils';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import { userMixin } from '@/mixins/user';
import BaseLoading from '@/components/BaseLoading';
import { mapState } from 'vuex';
import domain_service from '@/apps/data-platform/services/master_data/domain_service';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import DialogsComponent from '@/components/DialogsComponent.vue';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import FormAccessRequest from '@/components/FormAccessRequest.vue';
import MyPendingsService from '@/apps/data-platform/services/tables_views/my_pendings_service';
export default {
  name: 'AccessManagementReportPage',
  mixins: [userMixin],
  components: {
    BaseLoading: BaseLoading,
    PaginationBasic: PaginationBasic,
    ModalConfirm: ModalConfirm,
    DialogConfirmationComponent: DialogConfirmationComponent,
    OrganizacionComponent: OrganizacionComponent,
    FormAccessRequest: FormAccessRequest,
    DialogsComponent: DialogsComponent
  },
  data: function data() {
    var _ref;
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() - 1);
    var TYPE_ACCESS = 'Access';
    var TYPE_EXPIRATION = 'Expiration';
    return _ref = {
      activeTab: 0,
      key_table_show_details: 0,
      key_table: 0,
      key_pagination: 1,
      modalId: 'dp_AccessManagementReport',
      modalName: 'Access Management',
      MODAL_CONFIRM_REMOVE_ACCESS: 'MODAL_CONFIRM_REMOVE_ACCESS',
      MODAL_RENEW_ACCESS: 'MODAL_RENEW_ACCESS',
      TYPE_INTERVAL_ACCESS: TYPE_ACCESS,
      TYPE_INTERVAL_EXPIRATION: TYPE_EXPIRATION,
      TYPE_EVENT_SEARCH: 'search',
      TYPE_EVENT_CREATE: 'create',
      TYPE_EVENT_CLEAN: 'clean',
      tplToUpdate: {},
      pagination: {
        current: 1,
        limit: envConfig.pagintaionSize,
        total: 0,
        next: false,
        offset: 0,
        sort_by: ['lastUpdateTime'],
        sort_desc: [true],
        cursor: null,
        cursor_version: null,
        cursors: [null],
        cursors_version: [null]
      },
      paginationColumnsViews: {
        current: 1,
        limit: envConfig.pagintaionSize,
        total: 0,
        offset: 0,
        sort_by: ['lastUpdateTime'],
        sort_desc: [true]
      },
      paginationPermissions: {
        current: 1,
        limit: envConfig.pagintaionSize,
        total: 0,
        offset: 0
      },
      wrnngmsg: '',
      options: [{
        value: null,
        text: 'All'
      }, {
        value: true,
        text: 'Active'
      }, {
        value: false,
        text: 'Inactive'
      }],
      optionsTypeDate: [{
        value: null,
        text: 'Select an option'
      }, {
        value: TYPE_ACCESS,
        text: TYPE_ACCESS
      }, {
        value: TYPE_EXPIRATION,
        text: TYPE_EXPIRATION
      }],
      drvr_cllctn_data: [],
      filterUsers: [],
      filterUsersCopy: [],
      items: [],
      projectList: [],
      srch_option: false,
      fltr_document: '',
      emailBenefited: '',
      emailApplicant: '',
      tableId: '',
      fltr_obj_status: null,
      fltr_obj_tblProjectId: '',
      fltr_obj_tblDatasetId: '',
      fltr_obj_tblObjectId: '',
      maxDate: today,
      maxDateAccessDate: maxDate,
      fltr_obj_a_creationTime: '',
      fltr_obj_b_creationTime: '',
      fltr_obj_a_ExpirationDate: '',
      fltr_obj_b_ExpirationDate: '',
      item: {},
      isBusy: false,
      timerTable: null,
      isValidatingFilters: false,
      tableValidated: false,
      typeInterval: null,
      isLoading: false
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "key_table", 0), "expanded", []), "filter_enabled", false), "collapse_filter", false), "domain_filter", ''), "list_orgs", []), "is_loading", false), "projectFilter", []), "access_list", []), "columns_list", []), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "authorized_views", []), "item_view", {}), "show_permissions", false), "loading_data", false);
  },
  created: function created() {
    this.is_loading = true;
    this.domain_filter = window.userInfo.domain;
    this.getProjects();
    this.cDomain = this.userDomain;
    this.movePage(this.TYPE_EVENT_CREATE);
    this.getListOrgsDetailed();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isDomainItc', 'companyCode'])), {}, {
    filtersValidated: function filtersValidated() {
      return this.typeInterval != null && (this.fltr_obj_a_creationTime == '' && this.fltr_obj_b_creationTime == '' || this.fltr_obj_a_ExpirationDate == '' && this.fltr_obj_b_ExpirationDate == '');
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('monitoring.subtitle_management'),
        disabled: true
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    fieldUser: function fieldUser() {
      return [{
        key: 'benefited',
        label: this.traductor('tablas.benefited'),
        stickyColumn: true
      },
      /*{
        thStyle: { width: '130px !important' },
        key: 'applicant',
        label: this.traductor('tablas.applicant')
      },*/
      {
        thStyle: {
          width: '90px !important'
        },
        key: 'application',
        label: this.traductor('tablas.application')
      }, {
        thStyle: {
          width: '130px !important'
        },
        key: 'createDate',
        label: this.traductor('tablas.first_interaction')
      }, {
        thStyle: {
          width: '130px !important'
        },
        key: 'lastUpdateTime',
        label: this.traductor('tablas.last_interaction')
      }, {
        thStyle: {
          width: '160px !important'
        },
        key: 'navigator',
        label: ''
      }, {
        key: 'actions',
        label: '',
        class: 'text-center'
      }];
    },
    headers: function headers() {
      return [{
        value: 'benefited',
        text: this.traductor('monitoring.tablas_monitoring.benefited'),
        width: '20%'
      }, {
        value: 'applicant',
        text: this.traductor('monitoring.tablas_monitoring.applicant'),
        width: '20%'
      }, {
        value: 'tblId',
        text: this.traductor('monitoring.tablas_monitoring.table_id'),
        width: '20%'
      }, {
        value: 'viwId',
        text: this.traductor('monitoring.tablas_monitoring.view_id'),
        width: '20%'
      }, {
        value: 'status',
        text: this.traductor('monitoring.tablas_monitoring.status'),
        width: '4%'
      }, {
        value: 'data-table-expand',
        text: '',
        width: '3%'
      }, {
        value: 'actions',
        text: '',
        width: '3%'
      }];
    },
    fieldTables: function fieldTables() {
      return [{
        key: 'tblProjectId',
        label: this.traductor('tablas.table_project')
      }, {
        key: 'tblDatasetId',
        label: this.traductor('tablas.table_dataset')
      }, {
        key: 'tblObjectId',
        label: this.traductor('tablas.table')
      }, {
        key: 'viwProjectId',
        label: this.traductor('tablas.view_project')
      }, {
        key: 'viwDatasetId',
        label: this.traductor('tablas.view_dataset')
      }, {
        key: 'viwObjectId',
        label: this.traductor('tablas.view')
      }, {
        key: 'creationTime',
        label: this.traductor('tablas.creation_time')
      }, {
        key: 'permissionExpirationDate',
        label: this.traductor('tablas.expiration_date')
      }, {
        key: 'actions',
        label: this.traductor('tablas.actions'),
        class: 'text-center'
      }];
    },
    headers2: function headers2() {
      return [{
        value: 'tblProjectId',
        text: this.traductor('monitoring.tablas_monitoring.table_project')
      }, {
        value: 'tblDatasetId',
        text: this.traductor('monitoring.tablas_monitoring.table_dataset')
      }, {
        value: 'tblObjectId',
        text: this.traductor('monitoring.tablas_monitoring.table')
      }, {
        value: 'viwProjectId',
        text: this.traductor('monitoring.tablas_monitoring.view_project')
      }, {
        value: 'viwDatasetId',
        text: this.traductor('monitoring.tablas_monitoring.view_dataset')
      }, {
        value: 'viwObjectId',
        text: this.traductor('monitoring.tablas_monitoring.view')
      }, {
        value: 'creationTime',
        text: this.traductor('monitoring.tablas_monitoring.creation_date')
      }, {
        value: 'permissionExpirationDate',
        text: this.traductor('monitoring.tablas_monitoring.expiration_date'),
        align: 'center'
      }, {
        value: 'approvalUser',
        text: this.traductor('monitoring.tablas_monitoring.approval_user'),
        width: '4%'
      }, {
        value: 'actions',
        text: this.traductor('monitoring.tablas_monitoring.actions'),
        class: 'text-center'
      }];
    },
    headers3: function headers3() {
      return [{
        value: 'role',
        text: "Rol"
      }, {
        value: 'userByEmail',
        text: "usuario"
      }];
    },
    headers4: function headers4() {
      return [{
        value: 'projectId',
        text: this.traductor('monitoring.tablas_monitoring.view_project')
      }, {
        value: 'datasetId',
        text: this.traductor('monitoring.tablas_monitoring.view_dataset')
      }, {
        value: 'tableId',
        text: this.traductor('monitoring.tablas_monitoring.view')
      }];
    },
    headers5: function headers5() {
      return [{
        value: 'name',
        text: this.traductor('monitoring.name')
      }, {
        value: 'type',
        text: this.traductor('monitoring.type')
      }, {
        value: 'description',
        text: this.traductor('monitoring.description')
      }, {
        value: 'sensitive',
        text: this.traductor('monitoring.sensitive')
      }];
    }
  }),
  mounted: function mounted() {
    var wrapper_1 = document.querySelector('.table-reference .v-data-table__wrapper');
    var wrapper_2 = document.querySelector('#wrapper2');
    wrapper_1.onscroll = function () {
      wrapper_2.scrollLeft = wrapper_1.scrollLeft;
    };
    wrapper_2.onscroll = function () {
      wrapper_1.scrollLeft = wrapper_2.scrollLeft;
    };
  },
  methods: {
    onTablePaginationChange: function onTablePaginationChange(event) {
      this.pagination.current = event.page;
      this.pagination.limit = event.itemsPerPage;
      this.pagination.sort_by = event.sortBy;
      this.pagination.sort_desc = event.sortDesc;
    },
    show_details: function show_details(item) {
      var _this = this;
      this.show_permissions = false;
      this.item = item;
      this.activeTab = 0;
      this.columns_list = [];
      this.access_list = [];
      this.authorized_views = [];
      this.$nextTick(function () {
        var tableWrapper = _this.$refs["modalShowDetails"].$el.querySelector(".v-data-table__wrapper");
        if (tableWrapper) {
          tableWrapper.dispatchEvent(new Event("resize"));
        }
        _this.key_table_show_details += 1;
      });
      this.showAccess(item.objects[0]);
      this.$refs["modalShowDetails"].onOpen();
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    showAccess: function showAccess(item) {
      var _this2 = this;
      this.show_permissions = true;
      this.item_view = {};
      var params2 = {
        "domain": item.domain,
        "projectId": item.viwProjectId,
        "datasetId": item.viwDatasetId
      };
      var params3 = {
        "domain": item.domain,
        "projectId": item.tblProjectId,
        "datasetId": item.tblDatasetId
      };
      var params4 = {
        "domain": item.domain,
        "projectId": item.viwProjectId,
        "datasetId": item.viwDatasetId,
        "tableId": item.viwObjectId
      };
      var payload_sensitive = {
        "domain_table": item.domain,
        "relativeResourceName": item.relativeResourceName,
        "pageSize": 10,
        "email": window.userInfo.email
      };
      this.item_view = Object.assign({}, item);
      this.authorized_views = [];
      this.access_list = [];
      this.columns_list = [];
      tasks.lockScreen.lock();
      this.activeTab = 0;
      Promise.all([MonitoringAccessService.viewAccess(params3).then(function (response) {
        response.data.forEach(function (x) {
          if (Object.keys(x).indexOf("view") !== -1 && [item.viwDatasetId].indexOf(x['view']['datasetId']) !== -1 && [item.viwProjectId].indexOf(x['view']['projectId']) !== -1 && [item.viwObjectId].indexOf(x['view']['tableId']) !== -1) {
            _this2.authorized_views.push(x.view);
          }
        });
        console.log("authorized_views", _this2.authorized_views);
      }), MonitoringAccessService.viewAccess(params2).then(function (response) {
        response.data.forEach(function (x) {
          if (Object.keys(x).indexOf("role") !== -1 && ["OWNER", "READER"].indexOf(x['role']) !== -1) {
            _this2.access_list.push(x);
          }
        });
        console.log("access_list", _this2.access_list);
      }), MonitoringAccessService.viewAccessTable(params4).then(function (response) {
        _this2.columns_list = response.data.schema.fields.map(function (field) {
          return {
            name: field.name,
            type: field.type,
            description: field.description
          };
        });
        console.log("columns_list", _this2.columns_list);
      })]).then(function () {}).catch(function (error) {
        console.error("Error en las llamadas a viewAccess:", error);
      }).finally(function () {
        tasks.lockScreen.unlock();
        console.log("activeTab", _this2.activeTab);
        AssignmentsService.getListTagEntry(payload_sensitive).then(function (response) {
          var columns_with_sensitive_data = [];
          if (response && response.data && response.data.objects && response.data.objects.tags) {
            columns_with_sensitive_data = response.data.objects.tags;
          }
          var columnSensitiveMap = columns_with_sensitive_data.reduce(function (acc, item) {
            if (item.fields && item.fields.sensitive && item.fields.sensitive.boolValue !== undefined) {
              acc[item.column] = item.fields.sensitive.boolValue;
            }
            return acc;
          }, {});
          console.log("this.columns_list", _this2.columns_list);
          // Actualizar el array original usando el mapa
          _this2.columns_list = _this2.columns_list.map(function (item) {
            var sensitive = "";
            if (columnSensitiveMap[item.name]) {
              sensitive = "sí";
            }
            return _objectSpread(_objectSpread({}, item), {}, {
              sensitive: sensitive
            });
          });
          console.log("arrayActualizado", _this2.columns_list);
        }).catch(function (error) {
          console.error("Error fetching sensitive data:", error);
        });
      });
    },
    onLoadNewDomain: function onLoadNewDomain() {
      this.movePage(this.TYPE_EVENT_CREATE);
      this.assignProjects(this.domain_filter);
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this3 = this;
      domain_service.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this3.list_orgs = response.data;
        }
      });
    },
    onEnableFilter: function onEnableFilter() {
      this.clearFilterData();
      this.filterData();
      this.key_table += 1;
      console.log("key ", this.key_table);
      this.filter_enabled = !this.filter_enabled;
    },
    onDownloadCSV: function onDownloadCSV() {
      var _this4 = this;
      this.isLoading = true;
      MonitoringDriverService.driverConnectionDownload(this.params).then(function (response) {
        if (response.success) {
          tasks.toast.success("El archivo le llegará a su correo.");
          _this4.$emit('submit', response.data);
        } else {
          tasks.toast.error(response.message ? response.message : "No se pudo realizar la descarga.");
        }
      }).catch(function (error) {
        console.error('Error al descargar el archivo CSV:', error);
      }).finally(function () {
        _this4.isLoading = false;
      });
    },
    // this process consumes the user role Insert Update service
    onDownload: function onDownload() {
      var columns = ['Benefited', 'Applicant', 'First_Access_Granted', 'Last_Access_Granted', 'Status', 'Table_project', 'Table_dataset', 'Table', 'View_project', 'View_datasetd', 'View', 'View_Creation_date', 'Expiration_date', 'Domain', 'flow_id'];
      var body = [columns.join(';')];
      var x, y;
      var row1 = [];
      var row12 = [];
      for (x = 0; x < this.filterUsers.length; x++) {
        row12 = this.filterUsers[x].objects;
        for (y = 0; y < row12.length; y++) {
          row1.push({
            Benefited: this.filterUsers[x].benefited,
            Applicant: this.filterUsers[x].applicant,
            Application: this.filterUsers[x].application,
            First_Access_Granted: this.filterUsers[x].createDate,
            Last_Access_Granted: this.filterUsers[x].lastUpdateTime,
            Status: row12[y].status,
            Table_project: row12[y].tblProjectId,
            Table_dataset: row12[y].tblDatasetId,
            Table: row12[y].tblObjectId,
            View_project: row12[y].viwProjectId,
            View_datasetd: row12[y].viwDatasetId,
            View: row12[y].viwObjectId,
            View_Creation_date: row12[y].creationTime,
            Expiration_date: row12[y].permissionExpirationDate,
            Domain: row12[y].domain,
            flow_id: this.filterUsers[x].flow_id
          });
        }
      }
      var row = [];
      for (var _i = 0, _row = row1; _i < _row.length; _i++) {
        var record = _row[_i];
        var _iterator = _createForOfIteratorHelper(columns),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var column = _step.value;
            row.push(record[column]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        row = row.join(';');
        body.push(row);
        row = [];
      }
      var data = body.join('\n');
      var fileName = "".concat(this.modalId, ".csv");
      tasks.saveData(data, fileName);
    },
    clearFilterData: function clearFilterData() {
      this.srch_option = false;
      this.emailBenefited = '';
      this.emailApplicant = '';
      this.tableId = '';
      this.fltr_obj_tblProjectId = '';
      this.fltr_obj_tblDatasetId = '';
      this.fltr_obj_tblObjectId = '';
      this.fltr_obj_status = null;
      this.fltr_obj_a_creationTime = '';
      this.fltr_obj_b_creationTime = '';
      this.fltr_obj_a_ExpirationDate = '';
      this.fltr_obj_b_ExpirationDate = '';
    },
    filterData: function filterData() {
      this.srch_option = true;
      this.fltr_obj_tblProjectId = '';
      this.fltr_obj_tblDatasetId = '';
      this.fltr_obj_tblObjectId = '';
      this.fltr_obj_status = null;
      this.fltr_obj_a_creationTime = '';
      this.fltr_obj_b_creationTime = new Date().toISOString().slice(0, 10);
      this.fltr_obj_a_ExpirationDate = '';
      this.fltr_obj_b_ExpirationDate = '';
    },
    searchDocument: function searchDocument() {
      var _this5 = this;
      this.isLoading = true;
      var params = {
        document_id: this.fltr_document
      };
      MonitoringDriverService.driverConnectionDocument(params).then(function (response) {
        _this5.filterUsers = [];
        var document = response.data;
        if (document) {
          var benefited = document.document_id;
          var isExternalUser = document.configuration.esExternalUser || false;
          var isServiceAccount = document.configuration.isServiceAccount || false;
          var documentInsert = {
            applicant: document.applicant,
            application: document.application,
            createTime: document.configuration.createTime,
            isExternalUser: isExternalUser,
            isServiceAccount: isServiceAccount,
            isValidateTable: document.configuration.isValidateTable,
            isValidateTableColumn: document.configuration.isValidateTableColumn,
            createDate: document.createDate,
            benefited: benefited,
            lastUpdateTime: document.configuration.lastUpdateTime,
            id: document.document_id,
            objects: []
          };
          if (document.objects) {
            documentInsert.objects = document.objects.map(function (object) {
              return {
                benefited: benefited,
                isExternalUser: isExternalUser,
                isServiceAccount: isServiceAccount,
                tblDatasetId: object.table.datasetId,
                tblId: object.table.id,
                tblLocation: object.table.location,
                tblObjectId: object.table.objectId,
                tblProjectId: object.table.projectId,
                viwDatasetId: object.view.datasetId,
                viwId: object.view.id,
                viwLocation: object.view.location,
                viwObjectId: object.view.objectId,
                viwProjectId: object.view.projectId,
                creationTime: object.creationTime,
                days_to_expire: object.days_to_expire,
                domain: object.domain,
                lastModifiedTime: object.lastModifiedTime,
                permissionExpirationDate: object.permissionExpirationDate,
                status: object.status,
                organization: object.organization,
                flow_id: object.flow_id
              };
            });
          }
          _this5.filterUsers.push(documentInsert);
        }
      }).finally(function () {
        return _this5.isLoading = false;
      });
    },
    movePage: function movePage(event) {
      var _this6 = this;
      console.log(event);
      this.isLoading = true;
      var dataService;
      var res;
      this.drvr_cllctn_data.splice(0, this.drvr_cllctn_data.length);
      if (event == this.TYPE_EVENT_CLEAN) {
        this.clearFilterData();
      }
      if (event !== this.TYPE_EVENT_CREATE) {
        this.pagination.cursor = null;
        this.pagination.cursor_version = null;
        this.pagination.current = 1;
        this.pagination.cursors_version = [null];
      } else {
        console.log('this.pagination.current', this.pagination.current, 'else if');
        var index = this.pagination.current - 1;
        this.pagination.cursor = this.pagination.cursors[index];
        if (Array.isArray(this.pagination.cursors_version) && index >= 0 && index < this.pagination.cursors_version.length) {
          this.pagination.cursor_version = this.pagination.cursors_version[index];
        } else {
          this.pagination.cursor_version = null;
        }
      }
      console.log('this.pagination', this.pagination);
      this.params = {
        pagination: utils.cloneJSON(this.pagination),
        clauses: {
          domain: this.domain_filter,
          emailBenefited: this.emailBenefited,
          emailApplicant: this.emailApplicant,
          tableId: this.tableId.replace(".", ":")
        },
        filters_objects: []
      };
      this.params.pagination.limit += 1;
      var r = JSON.stringify(this.filterUsersCopy);
      this.filterUsers = JSON.parse(r); //Object.assign([], this.filterUsersCopy)
      console.log(this.filterUsers, "this. filter users");
      console.log('this.params', this.params);
      console.log('this.pagination', this.pagination);
      this.loading_data = true;
      MonitoringDriverService.driverConnectionQuery(this.params).then(function (response) {
        dataService = response.data.result;
        _this6.pagination.total = response.data.total;
        _this6.pagination.next = dataService.length > 0 && dataService.length === _this6.pagination.limit + 1;
        if (!_this6.pagination.cursors[_this6.pagination.current]) {
          _this6.pagination.cursors.push(response.data['next_cursor']);
        }
        if (!_this6.pagination.cursors_version[_this6.pagination.current] && event == _this6.TYPE_EVENT_SEARCH && _this6.params['clauses']['emailApplicant']) {
          _this6.pagination.cursors_version.push(response.data['next_cursor_version']);
        }
        console.log(_this6.pagination);
        res = response;
        _this6.loading_data = false;
      }).then(function () {
        if (dataService !== null) {
          _this6.items = dataService;
          if (dataService.length > 0) {
            _this6.wrnngmsg = 'ok';
          }
        } else if (event === _this6.TYPE_EVENT_SEARCH) {
          _this6.wrnngmsg = 'Not data found';
        }
        if (_this6.wrnngmsg === 'ok') {
          for (var i = 0; i < dataService.length; i++) {
            var benefited = dataService[i].document_id;
            var tblId = dataService[i].table.id.replace(":", ".");
            var isExternalUser = dataService[i] && dataService[i].configuration && dataService[i].configuration.esExternalUser || false;
            var isServiceAccount = dataService[i] && dataService[i].configuration && dataService[i].configuration.isServiceAccount || false;
            _this6.drvr_cllctn_data.push({
              applicant: dataService[i].applicant,
              tblId: tblId,
              viwId: dataService[i].view.id,
              status: dataService[i].permissionExpirationDate ? new Date(dataService[i].permissionExpirationDate) < new Date() ? 'Inactive' : 'Active' : 'Inactive',
              application: dataService[i].application,
              createTime: dataService[i] && dataService[i].configuration ? dataService[i].configuration.createTime : null,
              isExternalUser: isExternalUser,
              isServiceAccount: isServiceAccount,
              isValidateTable: dataService[i] && dataService[i].configuration ? dataService[i].configuration.isValidateTable : null,
              isValidateTableColumn: dataService[i] && dataService[i].configuration ? dataService[i].configuration.isValidateTableColumn : null,
              createDate: '',
              benefited: benefited,
              lastUpdateTime: '',
              //dataService[i].configuration.lastUpdateTime,
              id: dataService[i].view.id,
              objects: [],
              flow_id: dataService[i].flow_id
            });
            if (!_this6.drvr_cllctn_data[i].lastUpdateTime) _this6.drvr_cllctn_data[i].lastUpdateTime = dataService[i].lastModifiedTime;else {
              if (dataService[i].lastModifiedTime > _this6.drvr_cllctn_data[i].lastUpdateTime) _this6.drvr_cllctn_data[i].lastUpdateTime = dataService[i].lastModifiedTime;
            }
            if (!_this6.drvr_cllctn_data[i].createDate) _this6.drvr_cllctn_data[i].createDate = dataService[i].creationTime;else {
              var creationTime = new Date(dataService[i].creationTime);
              var currentCreateDate = new Date(_this6.drvr_cllctn_data[i].createDate);
              if (creationTime < currentCreateDate) {
                _this6.drvr_cllctn_data[i].createDate = dataService[i].creationTime;
              }
            }
            _this6.drvr_cllctn_data[i].objects.push({
              benefited: benefited,
              isExternalUser: isExternalUser,
              isServiceAccount: isServiceAccount,
              tblDatasetId: dataService[i].table.datasetId,
              tblId: tblId,
              tblLocation: dataService[i].table.location,
              tblObjectId: dataService[i].table.objectId,
              tblProjectId: dataService[i].table.projectId,
              viwDatasetId: dataService[i].view.datasetId,
              viwId: dataService[i].view.id,
              viwLocation: dataService[i].view.location,
              viwObjectId: dataService[i].view.objectId,
              viwProjectId: dataService[i].view.projectId,
              creationTime: dataService[i].creationTime,
              days_to_expire: dataService[i].days_to_expire,
              domain: dataService[i].domain,
              lastModifiedTime: dataService[i].lastModifiedTime,
              permissionExpirationDate: dataService[i].permissionExpirationDate,
              status: dataService[i].status,
              organization: dataService[i].organization,
              source: dataService[i].source,
              approvalUser: dataService[i].approval_user,
              relativeResourceName: dataService[i].relativeResourceName,
              flow_id: dataService[i].flow_id
            });
          }
          _this6.filterUsers = _this6.drvr_cllctn_data;
          _this6.filterUsersCopy = Object.assign([], _this6.filterUsers);
        }
      }).finally(function () {
        return _this6.isLoading = false;
      });
    },
    changePage: function changePage(currentPage) {
      this.pagination.current = currentPage;
      this.pagination.offset = (this.pagination.current - 1) * this.pagination.limit;
      this.movePage(this.TYPE_EVENT_CREATE);
    },
    openModalEdit: function openModalEdit(item, modalName) {
      var _this7 = this;
      var document_driver = this.items.find(function (el) {
        return el.id === item.benefited;
      });
      console.log('document_driver:  ', document_driver);
      var objects = document_driver.objects;
      var object = objects.find(function (e) {
        return e.table.id === item.tblId;
      });
      console.log('object ', object);
      var rowData = utils.cloneJSON(object);
      var table = object.table;
      rowData.tableReference = {
        datasetId: table.datasetId,
        projectId: table.projectId,
        tableId: table.objectId
      };
      rowData.isExternalUser = document_driver.configuration.isExternalUser || false;
      rowData.isServiceAccount = document_driver.configuration.isServiceAccount || false;
      rowData.benefited = document_driver.id;
      rowData.domain_table = rowData.domain;
      rowData.endDate = rowData.permissionExpirationDate;
      var params = {
        relativeResourceName: object.relativeResourceName,
        domain_table: object.domain,
        source: item.source ? item.source : "bigquery"
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          var responseTPL = response.data;
          for (var i = 0; i < responseTPL.objects.tags.length; i++) {
            if (!responseTPL.objects.tags[i].fields.business_term) {
              if (responseTPL.objects.tags[i].column) {
                responseTPL.objects.tags[i].fields.business_term = {};
                responseTPL.objects.tags[i].fields.business_term.displayName = 'Business Term';
                responseTPL.objects.tags[i].fields.business_term.stringValue = '';
              }
            }
          }
          _this7.tplToUpdate = responseTPL;
          _this7.tplToUpdate.item = rowData;
          _this7.tplToUpdate.tipo = 'edicion';
          _this7.tplToUpdate.origin = 'mytables';
          _this7.$bvModal.show(modalName);
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    hideModalWrng: function hideModalWrng(event) {
      event.preventDefault();
      this.$refs['wrng-modal'].hide();
      this.wrnngmsg = '';
    },
    rowClass: function rowClass(item, type) {
      if (!item || type !== 'row') return;
      if (item.days_to_expire > 0) return 'table-success';
      if (item.days_to_expire <= 0) return 'table-danger';
    },
    showModalWithData: function showModalWithData(item, modalName) {
      this.item = item;
      this.$refs[modalName].onOpen();
      //this.$bvModal.show(modalName)
    },
    removeAccess: function removeAccess(item) {
      var _this8 = this;
      this.item = item;
      console.log(this.item);
      console.log("prueba aqui", this.item);
      if (!event) {
        this.$refs[this.MODAL_CONFIRM_REMOVE_ACCESS].onClose();
        return;
      }
      this.isBusy = true;
      var params = _objectSpread({}, this.item.objects[0]);
      console.log(params, "PARAAAAAAAAAAAAAAAAAAAAAMS");
      MonitoringAccessService.removeAccessTable(params).then(function (response) {
        console.log(response);
        _this8.isBusy = false;
        _this8.$refs[_this8.MODAL_CONFIRM_REMOVE_ACCESS].onClose();
        //this.$bvModal.hide(this.MODAL_CONFIRM_REMOVE_ACCESS)
        _this8.movePage(_this8.TYPE_EVENT_CREATE);
      });
    },
    getProjects: function getProjects() {
      var _this9 = this;
      var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      ProjectsService.getAllProjects().then(function (response) {
        _this9.projectList = response.data.projects;
        _this9.assignProjects();
      }, function (err) {
        console.log(err);
      });
    },
    assignProjects: function assignProjects() {
      var _this0 = this;
      var org = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.userDomain;
      this.projectFilter = [];
      console.log("dbug:; ", org, this.projectList);
      this.projectList[org].forEach(function (project) {
        _this0.projectFilter.push({
          value: project,
          text: project
        });
      });
    },
    valid: function valid() {
      if (this.fltr_obj_tblProjectId === '') {
        tasks.toast.error('Set the project name!');
        // this.$toast.warning('Set the project name!')
        return false;
      }
      if (this.fltr_obj_tblDatasetId === '') {
        tasks.toast.error('Set the dataset name!');
        // this.$toast.warning('Set the dataset name!')
        return false;
      }
      if (this.fltr_obj_tblObjectId === '') {
        tasks.toast.error('Set the table name!');
        // this.$toast.warning('Set the table name!')
        return false;
      }
      return true;
    },
    onKeyUpTable: function onKeyUpTable(event) {
      var _this1 = this;
      this.fltr_obj_tblObjectId = event.target.value;
      clearTimeout(this.timerTable);
      this.timerTable = setTimeout(function () {
        if (_this1.fltr_obj_tblObjectId !== '') {
          _this1.isValidatingFilters = true;
          if (!_this1.valid()) {
            return;
          }
          var defaultParams = {
            values: {
              project_name: _this1.fltr_obj_tblProjectId,
              dataset_name: _this1.fltr_obj_tblDatasetId,
              table_name: _this1.fltr_obj_tblObjectId,
              source: 'bigquery'
            }
          };
          UserProfileService.validateTable(defaultParams).then(function (response) {
            if (response.code === 200 && response.success && response.data && response.data.id) {
              _this1.tableValidated = true;
            } else {
              tasks.toast.error("The table does not exists or it is not in 'prod' enviroment yet.");
              // this.$toast.warning("The table does not exists or it is not in 'prod' enviroment yet.")
            }
          }).finally(function () {
            _this1.isValidatingFilters = false;
          });
        }
      }, 500);
    },
    ReprocessAccess: function ReprocessAccess(item) {
      MyPendingsService.reprocessAccess(item).then(function (response) {
        if (response.code === 200) {
          tasks.toast.success("Acceso reprocesado");
        } else {
          tasks.toast.error("Ocurrió un error, intente luego.");
          // this.$toast.warning("The table does not exists or it is not in 'prod' enviroment yet.")
        }
      });
    }
  },
  watch: {
    /*fltr_obj_status(newStatus, oldStatus) {
      const data_copy = utils.cloneJSON(this.drvr_cllctn_data)
      switch (newStatus) {
        case null:
          this.filterUsers = data_copy
          break
        case true:
          this.filterUsers = data_copy.filter(item => {
            item.objects = item.objects.filter(object => object.days_to_expire > 0)
            return item.objects && item.objects.length > 0
          })
          break
        case false:
          this.filterUsers = data_copy.filter(item => {
            item.objects = item.objects.filter(object => object.days_to_expire <= 0)
            return item.objects && item.objects.length > 0
          })
          break
      }
    },*/
    typeInterval: function typeInterval(newValue, oldValue) {
      switch (newValue) {
        case null:
          this.typeInterval = null;
          this.fltr_obj_a_creationTime = '';
          this.fltr_obj_a_ExpirationDate = '';
          this.fltr_obj_b_ExpirationDate = '';
          this.params.filters_objects = this.params.filters_objects.filter(function (item) {
            return item.key !== 'creationTime' || item.key !== 'permissionExpirationDate';
          });
          break;
        case this.TYPE_INTERVAL_ACCESS:
          this.typeInterval = this.TYPE_INTERVAL_ACCESS;
          this.fltr_obj_a_creationTime = '';
          this.fltr_obj_a_ExpirationDate = '';
          this.fltr_obj_b_ExpirationDate = '';
          this.params.filters_objects = this.params.filters_objects.filter(function (item) {
            return item.key !== 'permissionExpirationDate';
          });
          break;
        case this.TYPE_INTERVAL_EXPIRATION:
          this.typeInterval = this.TYPE_INTERVAL_EXPIRATION;
          this.fltr_obj_a_creationTime = '';
          this.fltr_obj_a_ExpirationDate = '';
          this.fltr_obj_b_ExpirationDate = '';
          this.params.filters_objects = this.params.filters_objects.filter(function (item) {
            return item.key !== 'creationTime';
          });
          break;
      }
      console.log(this.params.filters_objects);
    }
  }
};